import PropTypes from "prop-types";
import Alert from "@shared/v2/Alert";
import { CircleCheckSolidV6 } from "@shared/v2/Icomoon";

// The card the transaction keeps once someone closes the order in Blueprint's portal. It draws no
// milestone ladder, no status rows and no timestamp: nothing about the order changes after this.
const CompleteStage = ({
  title = "Closing Finalized!",
  text = "Disbursement, recording, and policies issued. No further updates from Blueprint.",
}) => <Alert variant="success" icon={<CircleCheckSolidV6 size="l" />} title={title} text={text} />;

CompleteStage.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};

export default CompleteStage;
